var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2498 10.3334C16.2498 13.6011 13.6009 16.2501 10.3332 16.2501C7.06549 16.2501 4.4165 13.6011 4.4165 10.3334C4.4165 8.81757 4.98557 7.43642 5.9229 6.38916C6.42278 5.83064 7.02686 5.36786 7.70398 5.03136C8.49515 4.63818 9.38723 4.41675 10.3332 4.41675C13.6009 4.41675 16.2498 7.06573 16.2498 10.3334Z",
    stroke: "#96989C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1296 15.0991L15.1446 14.0841L19.3727 18.3939C19.6484 18.6749 19.6463 19.1256 19.3679 19.404C19.0857 19.6861 18.6276 19.6839 18.3481 19.3991L14.1296 15.0991Z",
    fill: "#96989C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonSearch);
export default __webpack_public_path__ + "static/media/commonSearch.a5b33c3d5a9238329f69bcdc9b51f987.svg";
export { ForwardRef as ReactComponent };